import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, Router } from '@angular/router';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiaryComplementsService } from '../../shared/services/beneficiaryComplements.service';
import { TitleService } from '../../shared/services/title.service';
import { BeneficiariesService } from '../../shared/services/beneficiaries.service';
import { BeneficiaryDto } from '../dto/beneficiary.dto';
import { BeneficiaryEmploymentService } from '../../shared/services/beneficiary-employment.service';
import { filter, takeUntil } from 'rxjs/operators';
import { BeneficiaryBaseComponent } from '../beneficiary-base.component';

@Component({
  selector: 'app-beneficiary-details',
  templateUrl: './beneficiary-details.component.html',
  styleUrls: ['./beneficiary-details.component.scss'],
  providers: [NgbNav],
  standalone: false,
})
export class BeneficiaryDetailsComponent extends BeneficiaryBaseComponent implements OnInit, OnDestroy {
  public activeTabId: string = 'personaldata';
  public id: number;

  constructor(
    private readonly titleService: TitleService,
    private readonly beneficiaryService: BeneficiariesService,
    private readonly complementService: BeneficiaryComplementsService,
    private readonly employmentService: BeneficiaryEmploymentService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    super();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationCancel),
        takeUntil(this.destroy$),
      )
      .subscribe(() => (this.activeTabId = this.route.firstChild.routeConfig.path));
  }

  public async ngOnInit(): Promise<void> {
    this.id = +this.route.snapshot.paramMap.get('id');

    if (this.id !== 0) {
      this.beneficiary = await this.beneficiaryService.findById(this.id);
      if (this.beneficiary) {
        this.titleService.setTitle('Fiche de ' + this.beneficiary.firstName + ' ' + this.beneficiary.usualName);
      }
      this.beneficiaryService.beneficiaryUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateBeneficiaryDetails(this.beneficiary.id);
      });
      this.complementService.complementUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateBeneficiaryDetails(this.beneficiary.id);
      });
      this.employmentService.employmentUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.updateBeneficiaryDetails(this.beneficiary.id);
      });
    } else {
      this.beneficiary = {} as BeneficiaryDto;
      this.titleService.setTitle("Création d'un bénéficiaire / participant");
    }

    this.beneficiaryService.beneficiary.setValue(this.beneficiary);
    if (this.route.firstChild.routeConfig.path) {
      this.activeTabId = this.route.firstChild.routeConfig.path;
    }
  }

  public onNavChange(event: NgbNavChangeEvent): void {
    this.router.navigate([event.nextId], { relativeTo: this.route });
    this.activeTabId = event.nextId;
  }

  private async updateBeneficiaryDetails(id: number): Promise<void> {
    this.beneficiary = await this.beneficiaryService.findById(id);
    this.beneficiaryService.beneficiary.setValue(this.beneficiary);
  }
}
